import styled, { css } from 'styled-components';

export const Container = styled.div`
	display: grid;
	grid-template-columns: minmax(250px, auto) minmax(50px, 435px);

	@media only screen and (min-device-width: 768px) and (max-device-width: 768px) {
		grid-template-columns: minmax(50px, auto) minmax(50px, 250px);
	}

	@media only screen and (min-device-width: 820px) and (max-device-width: 820px) {
		grid-template-columns: minmax(50px, auto) minmax(50px, 300px);
	}

	@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
		grid-template-columns: minmax(50px, auto) minmax(50px, 340px);
	}

	column-gap: 8px;
`;

export const MarginLeft = styled.div<{ $left?: boolean }>`
	${props =>
		props.$left &&
		css`
			margin-left: 25px;
		`};
`;

export const TypographyContainer = styled.div`
	width: 277px;
	text-align: center;
`;
